import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.625 8.469h15.75M6.661 2v1.688M18.125 2v1.688m0 0H6.875A3.375 3.375 0 0 0 3.5 7.063v11.25a3.375 3.375 0 0 0 3.375 3.375h11.25a3.375 3.375 0 0 0 3.375-3.375V7.063a3.375 3.375 0 0 0-3.375-3.375m-2.812 10.968H9.686"
    />
  </svg>
);
export default SvgCalendarMinus;
